import {
  LARGE_IMAGE_SIZE,
  MEDIUM_IMAGE_SIZE,
  SMALL_IMAGE_SIZE,
  MAP_PROVIDERS
} from '../constants';

export const STATES = {
  initializing: '@states/INITIALIZING',
  loading: '@states/LOADING',
  idle: '@states/IDLE',
  error: '@states/ERROR'
} as const;

export const EVENTS = {
  fetchMapSuccess: 'xstate.done.actor.fetchMap',
  fetchMapError: 'xstate.error.actor.fetchMap'
} as const;

export type MapUrls = {
  [SMALL_IMAGE_SIZE]: string;
  [MEDIUM_IMAGE_SIZE]: string;
  [LARGE_IMAGE_SIZE]: string;
};

export interface MapContext {
  error?: unknown;
  mapUrls?: MapUrls;
  locations: string[];
  zoom?: number;
  provider?: (typeof MAP_PROVIDERS)[keyof typeof MAP_PROVIDERS];
}

export type FetchMapInput = Pick<MapContext, 'locations' | 'zoom'>;

export type MapEvent =
  | { type: typeof EVENTS.fetchMapSuccess; output: MapUrls }
  | { type: typeof EVENTS.fetchMapError; error: unknown };
